module.exports = __webpack_public_path__ + "static/1-1dcc3efbe037c91ab53a2363aa07fa6d.jpg";